<template>
		<div id="main">
			<div id="winlogin">
				<div class="winloginFrame">
					<div class="winlogo"><img src="~@/assets/img/loginwin.png"></div>
					<div class="winTitle">请用微信扫码登录</div>
					<div class="ewm"></div>
					<div class="safe">扫码登录代表您同意本站《用户条款》与《免责条款》</div>
					<div class="winloginClose" onclick="winloginClose()"><img src="~@/assets/img/close.png" style="margin-top:45px"></div>
				</div>
			</div>
			<div class="menu">
				<div class="logo"><img src="~@/assets/img/logo.png"></div>
				<div class="logotext">今领科技产品官网</div>
				<div class="menuIcon_index_select menuText">组件</div>
				<div class="menuIcon_model menuText"><a href="model.html">模板</a></div>
				<div class="menuIcon_study menuText">教程</div>
				<div class="menuIcon_made menuText">定制</div>
				<div class="menuLine"></div>
				<div class="menuCaseTitle">可视化解决方案</div>
				<div class="menuCaseFir">数字乡村</div>
				<div class="menuCase">数据中心</div>
				<div style="margin-top: 50px;position: absolute;bottom:50px"><a href="https://beian.miit.gov.cn/" style="color: #fff;text-decoration: none">闽ICP备18022407号-3</a></div>
			</div>
			<div class="content">
				<div class="frame">
					<div class="titleFrame">
						<div class="titleContent">
							<div class="leftText">可视化素材网</div>
							<div class="styleDL">
								<div class="sell">购买记录</div>
								<div class="collection">收藏</div>
								<div class="loginout">退出</div>
								<div class="login">登录</div>
							</div>
						</div>
					</div>
					<div class="ad">
						原创可视化模板VUE源码 + 模板专属组件 + 速成教程
						<div><img src="~@/assets/img/adtext.png"></div>
					</div>
					<div class="contentSelect">
						<div class="className">组件</div>
						<div class="allcontent">全部</div>
						<div v-for="(item,index) in assemblySortList" class="selectName">{{item.name}}</div>
						<div class="logoBig">
							<img src="~@/assets/img/iconBig.png">
						</div>
					</div>
					<div class="colorSelect">
						<div class="className">主题</div>
						<div class="allcontent">全部</div>
						<div v-for="(item,index) in themeSortList" class="colorselectName">
							<div :class="'colors'+(index+1)"></div>
							<div>{{item.name}}</div>
						</div>
					</div>
					<div class="contentLine"></div>


					<div class="contentlist">
						<div id="contentlistFrame">
							<div class="kong"></div>
							<div v-for="item in inforsList" class="list" onclick="winlogin()">
								<div class="listPic">
									<img :src="imgUrl+item.pic_path" alt="pic">
								</div>
								<div class="listText">
									<div class="listTitle">{{item.title}}</div>
									<div class="listLabel">
										<span>ID:{{item.infor_id}}</span>
										<span>绿魔</span>
										<span>图表特效</span>
										<span>VUE</span>
									</div>
									<div class="styleDL">
										<div class="iconlist"><img src="~@/assets/img/icon_list.png"></div>
										<div@click="openFile(item.download_file_path)" class="codeDown">下载组件源码</div>
										<div @click="openFile(item.download_pic_path)" class="pngDown">下载PNG</div>
									</div>
									<div class="logotitle"><img src="~@/assets/img/logo_little.png"></div>
								</div>
							</div>
							<!-- <div class="list">
								<div class="listPic">
									<img src="~@/assets/img/echarts.png">
								</div>
								<div class="listText">
									<div class="listTitle">Echarts柱图常规特效</div>
									<div class="listLabel">
										<span>ID:E101</span>
										<span>绿魔</span>
										<span>图表特效</span>
										<span>VUE</span>
									</div>
									<div class="styleDL">
										<div class="iconlist"><img src="~@/assets/img/icon_list.png"></div>
										<div class="codeDown">下载组件源码</div>
										<div class="pngDown">下载PNG</div>
									</div>
									<div class="logotitle"><img src="~@/assets/img/logo_little.png"></div>
								</div>
							</div>
							<div class="list">
								<div class="listPic">
									<img src="~@/assets/img/echarts.png">
								</div>
								<div class="listText">
									<div class="listTitle">Echarts柱图常规特效</div>
									<div class="listLabel">
										<span>ID:E101</span>
										<span>绿魔</span>
										<span>图表特效</span>
										<span>VUE</span>
									</div>
									<div class="styleDL">
										<div class="iconlist"><img src="~@/assets/img/icon_list.png"></div>
										<div class="codeDown">下载组件源码</div>
										<div class="pngDown">下载PNG</div>
									</div>
									<div class="logotitle"><img src="~@/assets/img/logo_little.png"></div>
								</div>
							</div>
							<div class="list">
								<div class="listPic">
									<img src="~@/assets/img/echarts.png">
								</div>
								<div class="listText">
									<div class="listTitle">Echarts柱图常规特效</div>
									<div class="listLabel">
										<span>ID:E101</span>
										<span>绿魔</span>
										<span>图表特效</span>
										<span>VUE</span>
									</div>
									<div class="styleDL">
										<div class="iconlist"><img src="~@/assets/img/icon_list.png"></div>
										<div class="codeDown">下载组件源码</div>
										<div class="pngDown">下载PNG</div>
									</div>
									<div class="logotitle"><img src="~@/assets/img/logo_little.png"></div>
								</div>
							</div>
							<div class="list">
								<div class="listPic">
									<img src="~@/assets/img/echarts.png">
								</div>
								<div class="listText">
									<div class="listTitle">Echarts柱图常规特效</div>
									<div class="listLabel">
										<span>ID:E101</span>
										<span>绿魔</span>
										<span>图表特效</span>
										<span>VUE</span>
									</div>
									<div class="styleDL">
										<div class="iconlist"><img src="~@/assets/img/icon_list.png"></div>
										<div class="codeDown">下载组件源码</div>
										<div class="pngDown">下载PNG</div>
									</div>
									<div class="logotitle"><img src="~@/assets/img/logo_little.png"></div>
								</div>
							</div>
							<div class="list">
								<div class="listPic">
									<img src="~@/assets/img/echarts.png">
								</div>
								<div class="listText">
									<div class="listTitle">Echarts柱图常规特效</div>
									<div class="listLabel">
										<span>ID:E101</span>
										<span>绿魔</span>
										<span>图表特效</span>
										<span>VUE</span>
									</div>
									<div class="styleDL">
										<div class="iconlist"><img src="~@/assets/img/icon_list.png"></div>
										<div class="codeDown">下载组件源码</div>
										<div class="pngDown">下载PNG</div>
									</div>
									<div class="logotitle"><img src="~@/assets/img/logo_little.png"></div>
								</div>
							</div>
							<div class="list">
								<div class="listPic">
									<img src="~@/assets/img/echarts.png">
								</div>
								<div class="listText">
									<div class="listTitle">Echarts柱图常规特效</div>
									<div class="listLabel">
										<span>ID:E101</span>
										<span>绿魔</span>
										<span>图表特效</span>
										<span>VUE</span>
									</div>
									<div class="styleDL">
										<div class="iconlist"><img src="~@/assets/img/icon_list.png"></div>
										<div class="codeDown">下载组件源码</div>
										<div class="pngDown">下载PNG</div>
									</div>
									<div class="logotitle"><img src="~@/assets/img/logo_little.png"></div>
								</div>
							</div>
							<div class="list">
								<div class="listPic">
									<img src="~@/assets/img/echarts.png">
								</div>
								<div class="listText">
									<div class="listTitle">Echarts柱图常规特效</div>
									<div class="listLabel">
										<span>ID:E101</span>
										<span>绿魔</span>
										<span>图表特效</span>
										<span>VUE</span>
									</div>
									<div class="styleDL">
										<div class="iconlist"><img src="~@/assets/img/icon_list.png"></div>
										<div class="codeDown">下载组件源码</div>
										<div class="pngDown">下载PNG</div>
									</div>
									<div class="logotitle"><img src="~@/assets/img/logo_little.png"></div>
								</div>
							</div>
							<div class="list">
								<div class="listPic">
									<img src="~@/assets/img/echarts.png">
								</div>
								<div class="listText">
									<div class="listTitle">Echarts柱图常规特效</div>
									<div class="listLabel">
										<span>ID:E101</span>
										<span>绿魔</span>
										<span>图表特效</span>
										<span>VUE</span>
									</div>
									<div class="styleDL">
										<div class="iconlist"><img src="~@/assets/img/icon_list.png"></div>
										<div class="codeDown">下载组件源码</div>
										<div class="pngDown">下载PNG</div>
									</div>
									<div class="logotitle"><img src="~@/assets/img/logo_little.png"></div>
								</div>
							</div>
							<div class="list">
								<div class="listPic">
									<img src="~@/assets/img/echarts.png">
								</div>
								<div class="listText">
									<div class="listTitle">Echarts柱图常规特效</div>
									<div class="listLabel">
										<span>ID:E101</span>
										<span>绿魔</span>
										<span>图表特效</span>
										<span>VUE</span>
									</div>
									<div class="styleDL">
										<div class="iconlist"><img src="~@/assets/img/icon_list.png"></div>
										<div class="codeDown">下载组件源码</div>
										<div class="pngDown">下载PNG</div>
									</div>
									<div class="logotitle"><img src="~@/assets/img/logo_little.png"></div>
								</div>
							</div>
							<div class="list">
								<div class="listPic">
									<img src="~@/assets/img/echarts.png">
								</div>
								<div class="listText">
									<div class="listTitle">Echarts柱图常规特效</div>
									<div class="listLabel">
										<span>ID:E101</span>
										<span>绿魔</span>
										<span>图表特效</span>
										<span>VUE</span>
									</div>
									<div class="styleDL">
										<div class="iconlist"><img src="~@/assets/img/icon_list.png"></div>
										<div class="codeDown">下载组件源码</div>
										<div class="pngDown">下载PNG</div>
									</div>
									<div class="logotitle"><img src="~@/assets/img/logo_little.png"></div>
								</div>
							</div>
							<div class="list">
								<div class="listPic">
									<img src="~@/assets/img/echarts.png">
								</div>
								<div class="listText">
									<div class="listTitle">Echarts柱图常规特效</div>
									<div class="listLabel">
										<span>ID:E101</span>
										<span>绿魔</span>
										<span>图表特效</span>
										<span>VUE</span>
									</div>
									<div class="styleDL">
										<div class="iconlist"><img src="~@/assets/img/icon_list.png"></div>
										<div class="codeDown">下载组件源码</div>
										<div class="pngDown">下载PNG</div>
									</div>
									<div class="logotitle"><img src="~@/assets/img/logo_little.png"></div>
								</div>
							</div>
							<div class="list">
								<div class="listPic">
									<img src="~@/assets/img/echarts.png">
								</div>
								<div class="listText">
									<div class="listTitle">Echarts柱图常规特效</div>
									<div class="listLabel">
										<span>ID:E101</span>
										<span>绿魔</span>
										<span>图表特效</span>
										<span>VUE</span>
									</div>
									<div class="styleDL">
										<div class="iconlist"><img src="~@/assets/img/icon_list.png"></div>
										<div class="codeDown">下载组件源码</div>
										<div class="pngDown">下载PNG</div>
									</div>
									<div class="logotitle"><img src="~@/assets/img/logo_little.png"></div>
								</div>
							</div>
							<div class="list">
								<div class="listPic">
									<img src="~@/assets/img/echarts.png">
								</div>
								<div class="listText">
									<div class="listTitle">Echarts柱图常规特效</div>
									<div class="listLabel">
										<span>ID:E101</span>
										<span>绿魔</span>
										<span>图表特效</span>
										<span>VUE</span>
									</div>
									<div class="styleDL">
										<div class="iconlist"><img src="~@/assets/img/icon_list.png"></div>
										<div class="codeDown">下载组件源码</div>
										<div class="pngDown">下载PNG</div>
									</div>
									<div class="logotitle"><img src="~@/assets/img/logo_little.png"></div>
								</div>
							</div> -->
							<div class="kong"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
</template>

<script>
    import "../css/common.css";
	import router from '@/router';
	import { Message } from 'element-ui'
	import { getInforsLists,getSortLists} from "@/api/index";



	// const phone = "17550313746";
	// console.log(phone.replace(/^(\d{3})\d{4}(\d{4})/, '$1****$2'));

	export default {
		data() {
			return {
				value2: '',
				ListDataSelf: [], // 特殊人群分布
				ListData2: [], // 县区人口概况
				ListData44: [],
				Sqid: 0, // 社区ID
				allData: {},
				winFrame: false,
				nowtime: '',
				activityList: [],
				timer1: null,
				scrollTime: 50,
				options: [{
					value: '选项1',
					label: '农场一'
				}, {
					value: '选项2',
					label: '农场二'
				}],
				value: '',
				maFaRinkList:[],//满发小时排行
				noticeList:[],//公告列表
				socialData:{},//社会贡献数据
				warningData:{},//故障报警信息
				staticData:{},//统计信息
				isShowWarningDialog:false,//显示告警信息弹窗
				stationSearchStr:'',//站点搜索关键词
				stationSearchList:[],///搜索的站点列表
				isShowStationSearch:false,//是否显示下拉搜索
				realTime:null,
				realTime2:null,
				timer:null, 
				assemblySortList:[],//组件类别列表
				themeSortList:[],//主题类别列表
				inforsList:[],//信息列表
				imgUrl:'http://file.17886.cn',
			}
		},
		components: {

		},
		computed: {
			zoomAuto: function() {
				return document.documentElement.clientWidth / 1920; //自定义高度需求
			},
			Hframe: function() {
				console.log(window.screen.height);
				return window.screen.height / (document.documentElement.clientWidth / 1920) + "px"; //自定义高度需求
			}
		},
		filters: {
			formatDate: function (value) {
				let date = new Date(value);
				let y = date.getFullYear();
				let MM = date.getMonth() + 1;
				MM = MM < 10 ? ('0' + MM) : MM;
				let d = date.getDate();
				d = d < 10 ? ('0' + d) : d;
				let h = date.getHours();
				h = h < 10 ? ('0' + h) : h;
				let m = date.getMinutes();
				m = m < 10 ? ('0' + m) : m;
				let s = date.getSeconds();
				s = s < 10 ? ('0' + s) : s;
				return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
			}
		},
		mounted() {
			// // 显示时间1s1s的显示
			// this.realTime = this.dealWithTime(new Date())
			// this.realTime2 = this.dealWithTime2(new Date())
			// // 定时刷新时间
			// let _this = this
			// // 定时器
			// this.timer = setInterval(function () {
			// 	_this.realTime = _this.dealWithTime(new Date()) // 修改数据date
			// 	_this.realTime2 = _this.dealWithTime2(new Date()) // 修改数据date
			// }, 1000);
			this.getAssemblySortList();
			this.getThemeSortList();
			this.getInforsList();
		},
		methods: {
			openFile(path){
				path=this.imgUrl+path;
				window.open(path);
			},
			getInforsList(){
				var _this =this;
				getInforsLists(19).then(res => {
					if(res.status==1){
						_this.inforsList=res.data;
						console.log("_this.inforsList"+JSON.stringify(_this.inforsList));
					}
				});	
			},				
			getThemeSortList(){
				var _this =this;
				getSortLists(19).then(res => {
					if(res.status==1){
						_this.themeSortList=res.data;
						console.log("_this.themeSortList"+JSON.stringify(_this.themeSortList));
					}
				});	
			},			
			getAssemblySortList(){
				var _this =this;
				getSortLists(1).then(res => {
					if(res.status==1){
						_this.assemblySortList=res.data;
					}
				});	
			},	
			dealWithTime (data) {
				let formatDateTime
				let Y = data.getFullYear()
				let M = data.getMonth() + 1
				let D = data.getDate()
				//let H = data.getHours()
				//let Min = data.getMinutes()
				// let S = data.getSeconds()
				let W = data.getDay()
				// H = H < 10 ? ('0' + H) : H
				// Min = Min < 10 ? ('0' + Min) : Min
				// S = S < 10 ? ('0' + S) : S
				switch (W) {
					case 0:
					W = '天'
					break
					case 1:
					W = '一'
					break
					case 2:
					W = '二'
					break
					case 3:
					W = '三'
					break
					case 4:
					W = '四'
					break
					case 5:
					W = '五'
					break
					case 6:
					W = '六'
					break
					default:
					break
				}
				formatDateTime = Y + '年' + M + '月' + D + '日 ' + '星期' + W;
				return formatDateTime
			},
			dealWithTime2 (data) {
				let formatDateTime
				//let Y = data.getFullYear()
				//let M = data.getMonth() + 1
				//let D = data.getDate()
				let H = data.getHours()
				let Min = data.getMinutes()
				let S = data.getSeconds()
				//let W = data.getDay()
				H = H < 10 ? ('0' + H) : H
				Min = Min < 10 ? ('0' + Min) : Min
				S = S < 10 ? ('0' + S) : S
				// switch (W) {
				//   case 0:
				//     W = '天'
				//     break
				//   case 1:
				//     W = '一'
				//     break
				//   case 2:
				//     W = '二'
				//     break
				//   case 3:
				//     W = '三'
				//     break
				//   case 4:
				//     W = '四'
				//     break
				//   case 5:
				//     W = '五'
				//     break
				//   case 6:
				//     W = '六'
				//     break
				//   default:
				//     break
				// }
				formatDateTime =  H + ':' + Min + ':' + S;
				return formatDateTime
			},			
			goStation(id){
			router.push({
				name:"site_detail",
				query:{
				"id":id
				}
			});
			},
			goSiteListPage(){
				router.push({
					name: 'site_list'
				});
			},			
			goWarningListPage(){
				router.push({
					name: 'warnings'
				});
			},				
			rollUp(t) {
				let ul1 = document.getElementById("publishMain1");
				let ul2 = document.getElementById("publishMain2");
				let box = document.getElementById("publishMain");

				ul2.innerHTML = ul1.innerHTML;
				box.scrollTop = 0;

				this.timer1 = window.setInterval(this.rollStart, t);
			},
			rollStart() {
				// 上面声明的DOM对象为局部对象需要再次声明
				// 无缝轮播需要两个相同内容的盒子
				let ul1 = document.getElementById("publishMain1");

				// var ul2 = document.getElementById("listbox2");

				let box = document.getElementById("publishMain");

				// 正常滚动不断给scrollTop的值+1,当滚动高度大于列表内容高度时恢复为0

				if (box.scrollTop+120 >= ul1.scrollHeight) {
					box.scrollTop = 0;
				} else {
					box.scrollTop++;
				}
				//console.log("box.scrollTop===="+box.scrollTop+"====ul1.scrollHeight:"+ul1.scrollHeight);
			},
			mouseenterEvent() {
				if (this.timer1) {
					clearInterval(this.timer1);
					this.timer1 = null;
				}
			},
			mouseleaveEvent(t) {
				console.log(1);
				if (!this.timer1) {
					this.timer1 = setInterval(this.rollStart, 50);
				}
			},			
			FormateTime() {
				var date = new Date();
				var year = this.formateTime(date.getFullYear())
				var month = this.formateTime(date.getMonth() + 1)
				var day = this.formateTime(date.getDate())
				var hour = this.formateTime(date.getHours())
				var minute = this.formateTime(date.getMinutes())
				var second = this.formateTime(date.getSeconds())
				var weekday = date.getDay();
				var weeks = new Array("星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六");
				var week = weeks[weekday];
				return year + '-' + month + '-' + day + '  ' + week + '  ' + hour + ":" + minute + ":" + second
			},
			formateTime(n) {
				if (n < 10) {
					return '0' + n
				} else {
					return n
				}
			},


		},

		beforeDestroy() {
			if (this.timer) {
				clearInterval(this.timer)
			};
			// 页面销毁清除定时器
			if (this.timer1) {
				clearInterval(this.timer1);
				this.timer1 = null;
			}			
		},
	}
</script>
<style scoped>
/deep/ .el-input.el-input--suffix {
  .el-input__inner {
    background: #183967 !important;
    border: 1px solid #165a83;
    color: #bed8d5;
    border-radius:0px;
	background:none !important;
	border:none !important;
	margin-top:-5px;
  }
  .el-input__suffix-inner {
    position: absolute;
    left: -25px;
    background: #183967 !important;
    overflow:hidden;
    height:28px;
    top:0px;
	background: none !important;
  }
  .el-select-dropdown{
    background: #183967 !important;
  }
  .el-input__inner::placeholder {
    color: #bed8d5;
  }

  .el-icon-arrow-up:before {
    color: #bed8d5;
  }
}
</style>
<style>
.el-select-dropdown__list{
  background: #183967 !important;
  border:none;
  color:#fff;
}
.el-select-dropdown__list .hover{
  background:#165a83;
}  
.el-select-dropdown__item{
  color:#fff;
}
.popper__arrow{
  border-bottom-color:#165a83 !important;
}
.popper__arrow::after{
  border-bottom-color:#165a83 !important;
}
.el-select-dropdown{
  border:solid 1px #165a83 !important;
}
::-webkit-scrollbar{
  display:none !important;
}
  .el-input__icon{
	  line-height:5px !important;
  }
</style>


// WEBPACK FOOTER //
// src/views/index.vue